module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAK0lEQVR4AWM4fPREDxCPePz+49cGeuJ3m7ZNGhx4FI/iUTyKRzGoXKY3BgDsUYh5/uEwOAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_left+maincontainer.png
// module id = 350
// module chunks = 0